import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthManagerService } from '../../shared/services/auth-manager.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authManager: AuthManagerService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    var isAuth : Observable<boolean> = this.authManager.getIsAuthenticated();

    isAuth.subscribe(item => {
      if (!item) {
        // ReSharper disable once StringLiteralTypo
        this.router.navigate(['/sessionexpired'], { queryParams: { returnUrl: state.url } });
      }
    });
    
    return isAuth;
  }
}
